import React from 'react';
import { Await, useAsyncValue, useLoaderData } from 'react-router-dom';
import { GetDWHSegmentsListResponse } from 'services/apiService';
import { CircularProgress } from '@mui/material';
import Box from "@mui/material/Box";
import { useMemo } from 'react';
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';
import { SegmentListItem } from './../../services/apiService';
import { GridRenderEditCellParams } from '@mui/x-data-grid';
import { format } from 'date-fns';
// import { DataGridPro } from '@mui/x-data-grid-pro';

const SegmentsTable = ({ segments_list }: { segments_list: SegmentListItem[] }) => {
    const [pageSize, setPageSize] = React.useState<number>(5);
    let segmentsList = [...segments_list].sort((a, b) => b.creation_date - a.creation_date);

    const columns: GridColDef[] = [
        { field: 'dwh_segment_id', headerName: 'ID', width: 50 },
        { field: 'campaign', headerName: 'Campaign', width: 480 },
        { field: 'advertiser', headerName: 'Advertiser', width: 150 },
        { field: 'country', headerName: 'Country', width: 70 },
        {
            field: 'creation_date', headerName: 'Creation date', width: 130,
            renderCell: (params: GridRenderEditCellParams<string>) =>
                params.value
                    ? format(new Date(params.value), "dd/MM/yyyy HH:mm")
                    : "Invalid date format",
        },
        { field: 'dwh_base_id', headerName: 'DWH base id', width: 100 },
        { field: 'dwh_base_name', headerName: 'DWH base name', width: 180 },
        { field: 'router_list_id', headerName: 'Adressbook ID', width: 90 },
        { field: 'segment_status', headerName: 'Status', width: 110 },
        {
            field: 'shoot_date', headerName: 'Shoot date', width: 130,
            renderCell: (params: GridRenderEditCellParams<string>) =>
                params.value
                    ? format(new Date(params.value), "dd/MM/yyyy HH:mm")
                    : "Invalid date format",
        },
        { field: 'tag', headerName: 'Tag', width: 80 },
        { field: 'volume', headerName: 'Volume', width: 80 },
    ];

    return (
        <DataGrid className='MuiDataGrid-pinnedColumns--left' rows={segmentsList} columns={columns} components={{ Toolbar: GridToolbar }} getRowId={(row) => row.dwh_segment_id}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[5, 10, 20]}
            pagination
        />
    )
}

const Segments = () => {
    const dwhSegmentList = useAsyncValue() as GetDWHSegmentsListResponse
    const list_segment = useMemo(
        () => dwhSegmentList.list_segment,
        [dwhSegmentList]
    )
    console.log("list_segment : ", list_segment)
    return (
        <SegmentsTable segments_list={list_segment} />
    )
}

const SegmentList = () => {
    const loaderdata = useLoaderData() as {
        dwhSegments: Promise<GetDWHSegmentsListResponse>

    }
    console.log("segments : ", loaderdata.dwhSegments)
    return (
        <React.Suspense
            fallback={
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress />
                    <p>Fetching dwh requests...</p>
                </Box>
            }
        >
            <Await
                resolve={loaderdata.dwhSegments}
                errorElement={<p>Error while loading dwh segments data</p>}
            >
                <Segments />
            </Await>
        </React.Suspense>
    );
};


export default SegmentList;